export default {
  applications: {},
  contextMenu: {},
  contextMenuOpened: false,
  markerIndexCount: 1
}
